export default class EventTarget {

	#listeners = new Map();

	dispatchEvent(name, ...attr) {
		let list = this.#listeners.get(name);
		if (list) {
			for (let i = 0; i < list.length; i++) {
				const listElement = list[i];
				listElement(...attr);
			}
		}
		return this;
	}

	/**
	 * @param {String} name
	 * @param {Function} callback
	 * @return {EventTarget}
	 */
	addEventListener(name, callback) {
		let list = this.#listeners.get(name);
		if (!list) {
			list = [];
		}
		list.push(callback);
		this.#listeners.set(name, list);
		return this;
	}

	/**
	 * @param {String} name
	 * @param {Function|null} callback
	 * @return {EventTarget}
	 */
	removeEventListener(name, callback = null) {
		let list = this.#listeners.get(name);
		if (list) {
			if (callback === null) {
				this.#listeners.delete(name);
			} else {
				let index = list.indexOf(callback);
				if (index !== -1) {
					list.splice(index, 1);
					this.#listeners.set(name, list);
				}
			}
		}
		return this;
	}

}